import PropTypes from 'prop-types';
import moment from 'moment';

export default PropTypes.shape({
  startDate: PropTypes.instanceOf(moment),
  endDate: PropTypes.instanceOf(moment),
});
